var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-family":"Manrope"},attrs:{"id":"app"}},[_c('Navbar',{staticClass:"mb-5"}),_c('Content'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }